(function()
{
	var Application = include('springroll.Application');
	var Debug = include('springroll.Debug', false);
	var DelayedCall = include('springroll.DelayedCall');

	/**
	 * @class ControlCountdown
	 * @constructor
	 */
	var ControlCountdown = function()
	{
		/**
		 * Reference to the application
		 * @property {springroll.Application} app
		 */
		this.app = Application.instance;

		this.visible = false;
		this.framerate = 24;
		this.stop();

		// If control countdown is overriden in the config/ui/controlCountdown.json
		var pos = this.app.config.ui.controlCountdown;
		if (pos)
		{
			this.x = pos.x || this.x;
			this.y = pos.y || this.y;
			this.scaleX = pos.scale || this.scaleX;
			this.scaleY = pos.scale || this.scaleY;
		}

		this.hand.visible = app.hasTouch;
		this.cursor.visible = !app.hasTouch;

		this.animDelay = this.app.config.ui.controlCountdown.millescondsBefore321VO;
	};

	var p = ControlCountdown.prototype;

	/**
	 * Start the countdown (which is timed out using the flash timeline
	 * And has an emit('go', when the countdown reaches 0 (or, go)
	 */
	p.start = function(onGoCallback)
	{
		this.onGoEmitCatch = this.onGoEmitCatch.bind(this);
		this.onGoCallback = onGoCallback;
		// VO: get ready to take over in 3, 2, 1..
		this.app.voPlayer.play('Daisy_Tutorial_L28');
		this.activeDC = new DelayedCall(startCountdownAnim.bind(this), this.animDelay);
		DelayedCall.calls.push(this.activeDC);

		function startCountdownAnim()
		{
			this.once('go', this.onGoEmitCatch);
			this.visible = true;
			this.app.animator.play(
				this,
				'countdown',
				// Timeline emits 'go' before calling a this-remove callback
				this.destroy.bind(this)
			);
		}
	};

	/**
	 * ~szk: Because of the low frame rate emit bug, here is a buffer function that will fire the calback then set it to null, so when the animation containing the emit is done, it's callback can ALSO try to fire the callback (which, is destroy, because it self destroys)
	 */
	p.onGoEmitCatch = function()
	{
		this.off('go', this.onGoCallback);
		this.onGoCallback();
		this.onGoCallback = null;
	};

	p.destroy = function()
	{
		this.app.animator.stop(this);
		if (this.onGoCallback)
		{
			this.off('go', this.onGoCallback);
			this.onGoCallback();
			this.onGoCallback = null;
		}
		if (this.activeDC)
		{
			this.activeDC.destroy();
		}
		if (this.parent)
		{
			this.parent.removeChild(this);
		}
		this.animDelay = null;
	};

	namespace('nature').ControlCountdown = ControlCountdown;
}());